export const selectedFormat = () => {
  return document.querySelector("#labeltype").value;
};

const presets = [
  "fda/adult/vertical",
  "fda/adult/vertical/as_prepared",
  "fda/adult/vertical/aggregate",
  "fda/adult/vertical/100_gram",
  "fda/adult/tabular",
  "fda/adult/linear",
  "fda/infant/vertical",
  "fda/child/vertical",
  "canada/adult/vertical",
  "canada/adult/linear",
  "canada/adult/tabular",
  "canada/adult/vertical/as_prepared",
  "canada/adult/vertical/aggregate",
  "legacy_fda/adult/vertical",
  "legacy_fda/adult/tabular",
  "legacy_fda/adult/linear",
  "legacy_fda/adult/vertical/as_prepared",
  "legacy_fda/infant/vertical",
  "legacy_fda/child/vertical",
];

// Format is effectively the same as another format
const effectiveFormats = {
  "fda/adult/vertical/100_gram": "fda/adult/vertical",
  "canada/adult/vertical/100_gram": "canada/adult/vertical",
};

export const isFormat = (format) => {
  /* Prevent string typos: toggles.js only knows of these configurations */
  if (!presets.includes(format)) {
    throw new Error(`isFormat: invalid key "${format}"`);
  }

  return currentFormat() === format;
};

export const currentFormat = () => effectiveFormats[selectedFormat()] || selectedFormat();

export const isFDA = () => !!selectedFormat().match(/^fda\//);
export const isCanadian = () => !!selectedFormat().match(/^canada\//);
export const isLegacyFDA = () => !!selectedFormat().match(/^legacy_fda\//);

export const isAdult = () => !!selectedFormat().match(/\/adult\//);
export const isChild = () => !!selectedFormat().match(/\/child\//);
export const isInfant = () => !!selectedFormat().match(/\/infant\//);

export const isVertical = () => selectedFormat().match(/\/vertical/) && !isAPAP();
export const isTabular = () => !!selectedFormat().match(/\/tabular/);
export const isLinear = () => !!selectedFormat().match(/\/linear/);
export const isAPAP = () => !!selectedFormat().match(/\/as_prepared/);
export const isAggregate = () => !!selectedFormat().match(/\/aggregate/);
export const is100Gram = () => !!selectedFormat().match(/\/100_gram/);

export const onFormat = (handlers) => {
  /* Ensure no typos in handler keys */
  Object.keys(handlers).forEach((format) => {
    if (format !== "default" && !presets.includes(format)) {
      throw new Error(`onFormat: invalid key "${format}"`);
    }
  });

  if (!handlers["default"]) {
    presets.forEach((preset) => {
      if (!(handlers[preset] || handlers[effectiveFormats[preset]])) {
        throw new Error(`onFormat: missing handler for format "${preset}"`);
      }
    });
  }

  const fn =
    handlers[selectedFormat()] ||
    handlers[effectiveFormats[selectedFormat()]] ||
    handlers["default"];
  fn();
};
